export default __webpack_public_path__ + "static/media/bg-nail-club.4d65c0f0.jpg";